// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"49b45a75","129":"473e39c5","240":"01abdd48","241":"6eea016a","272":"9e2ac873","551":"52a3b548","611":"e43b5d22","674":"e410aa6f","902":"5858b4ca"}[chunkId] + ".chunk.js";
};